import React, { useEffect, useState } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import FileUpload from "../../Constant/fileupload";
import Select from "react-select";
import { searchVendorOptionApi } from "../../../services/SearchService";
import { getGrnNumberApi } from "../../../services/GrnService";
import CreatableSelect from "react-select/creatable";
import AddVendor from "../../Vendor/AddVendor";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const GRNForm = ({ form, errors, onChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorOptions, setVendoroption] = useState([]);
  const [grnNumber, setGrnNumber] = useState("");
  const [vendorAddmodal, setVendorAddModal] = useState(false);
  const [vendorInputValue, setVendorInputvalue] = useState("");

  const getVendorOption = () => {
    setVendorLoading(true);
    searchVendorOptionApi()
      .then((res) => {
        setVendoroption(res?.data?.results || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setVendorLoading(false);
      });
  };

  useEffect(() => {
    getVendorOption();
    getGrnNumberApi()
      .then((res) => {
        setGrnNumber(res?.data?.grn_number || "");
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    onChange({ ...form, grnNumber: grnNumber || "" });
  }, [grnNumber]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...form, [name]: value });
  };

  const handleSelectChange = (value, action) => {
    onChange({ ...form, [action.name]: value || "" });
  };

  const handleFileChange = (file) => {
    onChange({ ...form, invoiceAttachment: file });
  };

  const handleVendorAdd = (inputvalue) => {
    setVendorInputvalue(inputvalue);
    setVendorAddModal(true);
  };

  const handleVendorFormSubmit = (data) => {
    if (data?.data?.id) {
      const newOption = {
        label: data?.data?.name,
        value: data?.data?.id,
      };
      setVendoroption((prev) => [...prev, newOption]);
      onChange({ ...form, vendor: newOption });
    }
  };
  return (
    <div className="card mb-4">
      <div className="border-bottom d-flex justify-content-between align-items-center p-2">
        <div className="d-flex gap-2">
          <Link
            to="/grn"
            className="btn rounded-1 py-2 stylish-transparent-btn align-self-center"
          >
            <FaArrowLeft />
          </Link>
          <div>
            <h4 className="m-0">GRN Entry</h4>
            <small>Goods Receipt Note Entry</small>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm btn-transparent"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed ? (
              <FaChevronDown size={16} className="text-dark" />
            ) : (
              <FaChevronUp size={16} className="text-dark" />
            )}
          </button>
        </div>
      </div>
      {!isCollapsed && (
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-md-8">
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label text-dark">GRN Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="grnNumber"
                    value={form.grnNumber}
                    disabled
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark">Received Date</label>
                  <input
                    type="date"
                    className={`form-control ${
                      errors.receivedDate ? "is-invalid" : ""
                    }`}
                    name="receivedDate"
                    placeholder="Recieved Date"
                    value={form.receivedDate}
                    onChange={handleInputChange}
                    max={new Date().toISOString().split("T")[0]}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark">Vendor</label>
                  <CreatableSelect
                    options={vendorOptions}
                    name="vendor"
                    value={form?.vendor || null}
                    onChange={handleSelectChange}
                    classNamePrefix="select"
                    className="react-select"
                    placeholder="Optional"
                    isLoading={vendorLoading}
                    onCreateOption={handleVendorAdd}
                  />
                </div>
                <div className="col-md-8">
                  <label className="form-label text-dark">Remarks</label>
                  <textarea
                    className="form-control"
                    rows="1"
                    placeholder="Optional"
                    name="remarks"
                    value={form.remarks}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark">Invoice Number</label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.invoiceNumber ? "is-invalid" : ""
                    }`}
                    name="invoiceNumber"
                    value={form.invoiceNumber}
                    onChange={handleInputChange}
                    placeholder="INV-783439"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <FileUpload
                label="Upload Invoice PDF (required)"
                accept=".pdf"
                multiple={false}
                value={form.invoiceAttachment}
                onChange={(file) => handleFileChange(file)}
              />
              {
                errors?.invoiceAttachment&&(
                  <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                    Mandatory Field
                  </div>
                )
              }
            </div>
          </div>
        </div>
      )}
      <AddVendor
        name={vendorInputValue}
        showModal={vendorAddmodal}
        setShowModal={setVendorAddModal}
        onVendorAdded={(data) => handleVendorFormSubmit(data)}
      />
    </div>
  );
};

export default GRNForm;
